import { DataTable } from "@/core/components/layout/data-table";
import { Card, CardContent } from "@/core/components/ui/card";
import { Input } from "@/core/components/ui/input";
import { cn } from "@/core/utils";
import { DashboardFilters } from "@/dashboard/types";
import { Search } from "lucide-react";
import { useCallback, useEffect, useState } from "react";
import { useDashboardRankingsGroups } from "../../hooks/use-dashboard-rankings-groups";
import { DashboardRankingsSheet } from "../dashboard-rankings-sheet";
import { Top3Ranking } from "../top-3-ranking";

interface DashboardRankingsGroupsDataTableProps extends React.ComponentPropsWithoutRef<"div"> {
  filters: DashboardFilters;
  setTop3RankingData: (
    data: { position: number; name: string; value: number }[],
  ) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export const DashboardRankingsGroupsDataTable = ({
  filters,
  setTop3RankingData,
  setIsLoading,
  ...props
}: DashboardRankingsGroupsDataTableProps) => {
  const { table, isLoading, top3RankingData } =
    useDashboardRankingsGroups(filters);

  useEffect(() => {
    setTop3RankingData(top3RankingData);
    setIsLoading(isLoading);
  }, [top3RankingData, isLoading]);

  return (
    <div {...props}>
      <DataTable table={table} isLoading={isLoading} withoutPagination={true} />
    </div>
  );
};
